module.exports = __webpack_public_path__ + "img/logo.23524abe.png";